<template>
  <div class="laddercontroladvantage">
    <div class="header">
      <div class="title">智能梯控优势</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in laddercontroladvantageList"
          :key="item.id"
        >
          <div class="left">
            <img :src="item.logo" alt="" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import laddercontroladvantage1 from "../../../../assets/programme/laddercontroladvantage1.png";
import laddercontroladvantage2 from "../../../../assets/programme/laddercontroladvantage2.png";
import laddercontroladvantage3 from "../../../../assets/programme/laddercontroladvantage3.png";
import laddercontroladvantage4 from "../../../../assets/programme/laddercontroladvantage4.png";
import laddercontroladvantage5 from "../../../../assets/programme/laddercontroladvantage5.png";
import laddercontroladvantage6 from "../../../../assets/programme/laddercontroladvantage6.png";

export default {
  setup() {
    return reactive({
      laddercontroladvantageList: [
        {
          id: 1,
          title: "设定权限",
          text: "针对不同身份进行不同楼层出入的权限设置，分部门分区域管理。",
          logo: laddercontroladvantage1,
        },
        {
          id: 2,
          title: "便捷性强",
          text: "多种可供选择的乘梯方式，随时进行预约呼梯，操作便携",
          logo: laddercontroladvantage2,
        },
        {
          id: 3,
          title: "高效性强",
          text: "智能梯控，一键预约，人脸识别，自动到达权限楼层，无需按键操作。",
          logo: laddercontroladvantage3,
        },
        {
          id: 4,
          title: "使用数据记录",
          text: "出入过的楼层，都有相关数据统计记录，查阅方便，管理跟踪有保障。",
          logo: laddercontroladvantage4,
        },
        {
          id: 5,
          title: "安全性高",
          text: "不同楼层的业主拥有属于自己的独立楼层权限，无权限则无法进入，提高安全保障。",
          logo: laddercontroladvantage5,
        },
        {
          id: 6,
          title: "扩展功能",
          text: "联动监控系统，实时同步管控，进行电梯安全预防，智能云端监管。",
          logo: laddercontroladvantage6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.laddercontroladvantage {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item {
  display: flex;
  align-items: center;
  margin-bottom: 80px;
}
.body .list .item .left img {
  width: 72px;
  margin-right: 40px;
}
.body .list .item .right {
  width: 224px;
}
.body .list .item .right .title {
  font-size: 16px;
  color: #333;
}
.body .list .item .right .text {
  font-size: 14px;
  margin-top: 10px;
  color: #495a6c;
}
</style>
